<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-19 13:58:04
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-09-19 13:59:19
-->
<template>
    <router-view />
</template>

<script>
export default {
	name: 'InsureManage',
};
</script>